<template>
  <div class="header" :class="[computedClasses, $attrs.class]">
    <b-container fluid>
      <div class="header-body">
        <slot></slot>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "base-header",
  props: {
    type: {
      type: String,
      default: "success",
    },
  },
  computed: {
    computedClasses() {
      return this.type === "custom" ? "bg-gradient-custom" : `bg-${this.type}`;
    },
  },
};
</script>
<style scoped>
.bg-custom {
  background-color: #5a6872 !important;
}


</style>
